import "./Inventory.css";

import { Column, CursorDataGrid, Row, StackedBarChart } from "../../../../widget";
import { InventoryChartKey } from "./components";
import { useInventory } from "./useInventory";

const Inventory = (): JSX.Element => {
  const {
    onChange,
    columns,
    isLoading,
    hasProjectDetails,
    hasData,
    hasEnoughIssuancesForScrolling,
    unitMeasurement,
    xAxisLabels,
    stackedChartData,
    showAvailable,
    defaultSortingCriteria,
  } = useInventory();
  return (
    <div className="PublicProjectTabSection">
      <Row spacingV="ll">
        <Column span={12}>
          <h2>Inventory</h2>
        </Column>
      </Row>
      {stackedChartData && xAxisLabels && hasProjectDetails && hasData && (
        <Row spacingV="2xl">
          <Column span={12}>
            <StackedBarChart
              xLabels={xAxisLabels}
              data={stackedChartData}
              hasYAxisGridLines
              hasYAxisTicks
              showLegend={false}
            />
            <InventoryChartKey unitMeasurement={unitMeasurement} showAvailable={showAvailable} />
          </Column>
        </Row>
      )}
      {hasProjectDetails && (
        <Row spacingV={hasEnoughIssuancesForScrolling ? "ml" : undefined}>
          <Column span={12}>
            <div className={`ProjectInventoryDataGrid ${hasEnoughIssuancesForScrolling ? "Scrollable" : ""}`}>
              <CursorDataGrid
                columns={columns}
                clientSide={false}
                onChange={onChange}
                data={[]}
                defaultSortingCriteria={defaultSortingCriteria}
                pagination={{ pageSize: 1000 }}
                dataIsLoading={isLoading}
                noDataMessage="No inventory to display"
                hasTotalRow
                totalColumnNames={["unitQuantityAvailable", "unitQuantityTotal"]}
                infiniteScroll
              />
            </div>
          </Column>
        </Row>
      )}
    </div>
  );
};

export default Inventory;
